module.exports = __webpack_public_path__ + "img/paragon.a1e3ba7d.svg";